import AppointmentContainer from "./TwoFANotEnabledOTP.container";

export default AppointmentContainer;
